import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(array: any[], key: string, value: string | boolean | number | undefined | null): any[] {
    return array.filter(x => x[key] === value);
  }
}
